import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { useConfiguration } from "../hooks/useConfiguration";
import { useSaveCoveragePath } from "../hooks/useSaveCoveragePath";
import { useSaveDefaults } from "../hooks/useSaveDefaults";
import { useSaveRequestTypes } from "../hooks/useSaveRequestTypes";
import { useUnsavedChanges } from "../hooks/useUnsavedChanges";
import { STEPS, saveGroupForStep } from "../lib/steps";

export function StepFooter() {
  const { stepIndex, saving } = useConfiguration();
  const { requestStep } = useUnsavedChanges();
  const { save: saveCoveragePath } = useSaveCoveragePath();
  const { save: saveRequestTypes } = useSaveRequestTypes();
  const { save: saveDefaults } = useSaveDefaults();
  const step = STEPS[stepIndex];
  const group = saveGroupForStep(step.id);
  const save =
    group === "requests"
      ? saveRequestTypes
      : group === "defaults"
        ? saveDefaults
        : saveCoveragePath;

  return (
    <Stack
      direction="row"
      sx={{ mt: 3, justifyContent: "space-between", alignItems: "center" }}
    >
      <Button
        disabled={stepIndex === 0 || saving}
        onClick={() => requestStep(Math.max(0, stepIndex - 1))}
      >
        Previous
      </Button>
      <Stack direction="row" spacing={1}>
        {group ? (
          <Button
            variant="outlined"
            disabled={saving}
            onClick={() => void save()}
          >
            {saving ? "Saving…" : "Save"}
          </Button>
        ) : null}
        {step.id !== "review" ? (
          <Button
            variant="contained"
            disabled={saving}
            onClick={() =>
              requestStep(Math.min(STEPS.length - 1, stepIndex + 1))
            }
          >
            Next: {STEPS[Math.min(STEPS.length - 1, stepIndex + 1)].title}
          </Button>
        ) : null}
      </Stack>
    </Stack>
  );
}
